<div class="container-fluid" style="font-size: 14px;" *ngIf="row">
  <div class="d-flex flex-row justify-content-between align-items-center">
    <h2 class="title">GE Tag ID Update</h2>
    <button type="button" class="btn btn-primary d-flex justify-content-center align-items-center btn-add button" (click)="submit()" [disabled]="(status === row.incidentState) || row.incidentState === 'COMPLETED' || row.incidentState === 'RETURNED' || row.incidentState === 'REJECTED'">Save
    </button>
  </div>

  <mat-card *ngIf="row.comments" style="font-weight: 500; margin: 20px 0px;" [innerHTML]="row.comments"></mat-card>

  <form>

    <div class="row mx-0" style="font-size: 14px;">
      <div class="col-12 p-0">
        <div class="row m-0">
          <div class="col-xl-6 col-md-6 col-sm-6 p-0">
            <div class="col-xl-11 col-md-10 col-sm-12 col-12 p-0 pt-3 text-bold">Incident Number
            </div>
            <div class="col-xl-11 col-md-10 col-sm-12 col-12 p-0 disabled-input">
              <mat-form-field floatLabel="never" appearance="outline" class="col-12 p-0">
                <input [value]="row.incidentNumber" matInput readonly>
              </mat-form-field>
            </div>
          </div>
          <div class="col-xl-6 col-md-6 col-sm-6 p-0">
            <div class="col-xl-11 col-md-10 col-sm-12 col-12 p-0 pt-3 ml-auto text-bold">Incident Status
            </div>
            <div class="col-xl-11 col-md-10 col-sm-12 col-12 p-0 ml-auto">
              <!-- <mat-form-field floatLabel="never" appearance="outline" class="col-12 p-0">
                <input [value]="row.incidentState" matInput readonly>
              </mat-form-field> -->
              <mat-form-field appearance="outline" class="col-12 p-0">
                <mat-select [(ngModel)]="status" name="incidentState" (selectionChange)="onSelectionChange($event)">
                  <mat-option *ngFor="let incidentState of statuses" [value]="incidentState.value">
                    {{incidentState.viewValue}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
              <!-- <mat-form-field appearance="outline" class="col-12 p-0" *ngIf="!(row.incidentState !=='COMPLETED' && row.incidentState !== 'REJECTED')">
                <mat-select [(ngModel)]="status" name="incidentState" [disabled]="true">
                  <mat-option *ngFor="let incidentState of statuses" [value]="incidentState.value">
                    {{incidentState.viewValue}}
                  </mat-option>
                </mat-select>
              </mat-form-field> -->
            </div>
          </div>
        </div>
      </div>
    </div>
  
    <div class="row mx-0" style="font-size: 14px;">
      <div class="col-12 p-0">
        <div class="row m-0">
          <div class="col-xl-6 col-md-6 col-sm-6 p-0">
            <div class="col-xl-11 col-md-10 col-sm-12 col-12 p-0 pt-3 text-bold">Supplier Name
            </div>
            <div class="col-xl-11 col-md-10 col-sm-12 col-12 p-0 disabled-input">
              <mat-form-field floatLabel="never" appearance="outline" class="col-12 p-0">
                <input [value]="row.supplierName" matInput readonly>
              </mat-form-field>
            </div>
          </div>
          <div class="col-xl-6 col-md-6 col-sm-6 p-0">
            <div class="col-xl-11 col-md-10 col-sm-12 col-12 p-0 pt-3 ml-auto text-bold">Is this a new supplier?
            </div>
            <div class="col-xl-11 col-md-10 col-sm-12 col-12 p-0 ml-auto disabled-input">
              <mat-form-field floatLabel="never" appearance="outline" class="col-12 p-0">
                <input [value]="row.isNewSupplier" matInput readonly>
              </mat-form-field>
            </div>
          </div>
        </div>
      </div>
    </div>
  
    <div class="row mx-0" style="font-size: 14px;">
      <div class="col-12 p-0">
        <div class="row m-0">
          <div class="col-xl-6 col-md-6 col-sm-6 p-0">
            <div class="col-xl-11 col-md-10 col-sm-12 col-12 p-0 pt-3 text-bold">GSL & Site Code
            </div>
            <div class="col-xl-11 col-md-10 col-sm-12 col-12 p-0 disabled-input">
              <mat-form-field floatLabel="never" appearance="outline" class="col-12 p-0">
                <input [value]="row.gslNumber" matInput readonly>
              </mat-form-field>
            </div>
          </div>
          <div class="col-xl-6 col-md-6 col-sm-6 p-0">
            <div class="col-xl-11 col-md-10 col-sm-12 col-12 p-0 pt-3 ml-auto text-bold">Business
            </div>
            <div class="col-xl-11 col-md-10 col-sm-12 col-12 p-0 ml-auto disabled-input">
              <mat-form-field floatLabel="never" appearance="outline" class="col-12 p-0">
                <input [value]="row.business" matInput readonly>
              </mat-form-field>
            </div>
          </div>
        </div>
      </div>
    </div>
  
    <div class="row mx-0" style="font-size: 14px;">
      <div class="col-12 p-0">
        <div class="row m-0">
          <div class="col-xl-6 col-md-6 col-sm-6 p-0">
            <div class="col-xl-11 col-md-10 col-sm-12 col-12 p-0 pt-3 text-bold">Date GE ID Tags Needed
            </div>
            <div class="col-xl-11 col-md-10 col-sm-12 col-12 p-0 disabled-input">
              <mat-form-field floatLabel="never" appearance="outline" class="col-12 p-0">
                <input [value]="row.date | date:'yyyy-MM-dd'" matInput readonly>
              </mat-form-field>
            </div>
          </div>
          <div class="col-xl-6 col-md-6 col-sm-6 p-0">
            <div class="col-xl-11 col-md-10 col-sm-12 col-12 p-0 pt-3 ml-auto text-bold">Tag Request File
            </div>
            <div class="col-xl-11 col-md-10 col-sm-12 col-12 p-0 ml-auto disabled-input">
              <span class="text-normal" (click)="userFile(row.uploadedFileUrl)" style="position: absolute; margin-top: 1rem;">
                <img src="../../../../../assets/images/google-docs.svg" alt="" class="p-2" width="30" height="30">
                <span class="align-middle p-2" style="cursor: pointer;">Please click here to download the Tag Request file</span>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  
    <div class="row mx-0" style="font-size: 14px;">
      <div class="col-12 p-0">
        <div class="row m-0">
          <div class="col-xl-6 col-md-6 col-sm-6 p-0">
            <div class="col-xl-11 col-md-10 col-sm-12 col-12 p-0 pt-3 text-bold">Ship to Address
            </div>
            <div class="col-xl-11 col-md-10 col-sm-12 col-12 p-0 disabled-input">
              <mat-form-field floatLabel="never" appearance="outline" class="col-12 p-0">
                <input [value]="row.shipToAddress" matInput readonly>
              </mat-form-field>
            </div>
          </div>
          <div class="col-xl-6 col-md-6 col-sm-6 p-0">
            <div class="col-xl-11 col-md-10 col-sm-12 col-12 p-0 pt-3 ml-auto text-bold">Ship to City
            </div>
            <div class="col-xl-11 col-md-10 col-sm-12 col-12 p-0 ml-auto disabled-input">
              <mat-form-field floatLabel="never" appearance="outline" class="col-12 p-0">
                <input [value]="row.shipToCity" matInput readonly>
              </mat-form-field>
            </div>
          </div>
        </div>
      </div>
    </div>
  
    <div class="row mx-0" style="font-size: 14px;">
      <div class="col-12 p-0">
        <div class="row m-0">
          <div class="col-xl-6 col-md-6 col-sm-6 p-0">
            <div class="col-xl-11 col-md-10 col-sm-12 col-12 p-0 pt-3 text-bold">Ship to State/Province
            </div>
            <div class="col-xl-11 col-md-10 col-sm-12 col-12 p-0 disabled-input">
              <mat-form-field floatLabel="never" appearance="outline" class="col-12 p-0">
                <input [value]="row.shipToState" matInput readonly>
              </mat-form-field>
            </div>
          </div>
          <div class="col-xl-6 col-md-6 col-sm-6 p-0">
            <div class="col-xl-11 col-md-10 col-sm-12 col-12 p-0 pt-3 ml-auto text-bold">Ship to Postal Code
            </div>
            <div class="col-xl-11 col-md-10 col-sm-12 col-12 p-0 ml-auto disabled-input">
              <mat-form-field floatLabel="never" appearance="outline" class="col-12 p-0">
                <input [value]="row.shipToZip" matInput readonly>
              </mat-form-field>
            </div>
          </div>
        </div>
      </div>
    </div>
  
    <div class="row mx-0" style="font-size: 14px;">
      <div class="col-12 p-0">
        <div class="row m-0">
          <div class="col-xl-6 col-md-6 col-sm-6 p-0">
            <div class="col-xl-11 col-md-10 col-sm-12 col-12 p-0 pt-3 text-bold">Country
            </div>
            <div class="col-xl-11 col-md-10 col-sm-12 col-12 p-0 disabled-input">
              <mat-form-field floatLabel="never" appearance="outline" class="col-12 p-0">
                <input [value]="row.country" matInput readonly>
              </mat-form-field>
            </div>
          </div>
          <div class="col-xl-6 col-md-6 col-sm-6 p-0">
            <div class="col-xl-11 col-md-10 col-sm-12 col-12 p-0 pt-3 ml-auto text-bold">Ship to Contact Name
            </div>
            <div class="col-xl-11 col-md-10 col-sm-12 col-12 p-0 ml-auto disabled-input">
              <mat-form-field floatLabel="never" appearance="outline" class="col-12 p-0">
                <input [value]="row.shipToContactName" matInput readonly>
              </mat-form-field>
            </div>
          </div>
        </div>
      </div>
    </div>
  
    <div class="row mx-0" style="font-size: 14px;">
      <div class="col-12 p-0">
        <div class="row m-0">
          <div class="col-xl-6 col-md-6 col-sm-6 p-0">
            <div class="col-xl-11 col-md-10 col-sm-12 col-12 p-0 pt-3 text-bold">Phone Number
            </div>
            <div class="col-xl-11 col-md-10 col-sm-12 col-12 p-0 disabled-input">
              <mat-form-field floatLabel="never" appearance="outline" class="col-12 p-0">
                <input [value]="row.phoneNumber" matInput readonly>
              </mat-form-field>
            </div>
          </div>
          <div class="col-xl-6 col-md-6 col-sm-6 p-0">
            <div class="col-xl-11 col-md-10 col-sm-12 col-12 p-0 pt-3 ml-auto text-bold">Ship to Email Address
            </div>
            <div class="col-xl-11 col-md-10 col-sm-12 col-12 p-0 ml-auto disabled-input">
              <mat-form-field floatLabel="never" appearance="outline" class="col-12 p-0">
                <input [value]="row.emailAddress" matInput readonly>
              </mat-form-field>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row mx-0" style="font-size: 14px;">
      <div class="col-12 p-0">
        <div class="row m-0">
          <div class="col-xl-6 col-md-6 col-sm-6 p-0">
            <div class="col-xl-11 col-md-10 col-sm-12 col-12 p-0 pt-3 text-bold">Buyer Name
            </div>
            <div class="col-xl-11 col-md-10 col-sm-12 col-12 p-0 disabled-input">
              <mat-form-field floatLabel="never" appearance="outline" class="col-12 p-0">
                <input [value]="row.buyerName" matInput readonly>
              </mat-form-field>
            </div>
          </div>
          <div class="col-xl-6 col-md-6 col-sm-6 p-0">
            <div class="col-xl-11 col-md-10 col-sm-12 col-12 p-0 pt-3 ml-auto text-bold">Requestor Comments
            </div>
            <div class="col-xl-11 col-md-10 col-sm-12 col-12 p-0 ml-auto disabled-input">
              <mat-form-field floatLabel="never" appearance="outline" class="col-12 p-0">
                <input [value]="row.requestorComments" matInput readonly>
              </mat-form-field>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row mx-0" style="font-size: 14px;">
      <div class="col-12 p-0">
        <div class="row m-0">
          <div class="col-xl-6 col-md-6 col-sm-6 p-0">
            <div class="col-xl-11 col-md-10 col-sm-12 col-12 p-0 pt-3 text-bold">Tag Style
            </div>
            <div class="col-xl-11 col-md-10 col-sm-12 col-12 p-0 disabled-input">
              <mat-form-field floatLabel="never" appearance="outline" class="col-12 p-0">
                <input [value]="row.tagStyle" matInput readonly>
              </mat-form-field>
            </div>
          </div>
        </div>
      </div>
    </div>

  </form>
</div>

<ng-template #commentDialog>
  <div class="col-xl-11 col-md-10 col-sm-12 col-12 p-0 pt-3 text-bold">Additional Comments/ Feedback
  </div>
  <mat-dialog-content>
    <mat-form-field appearance="outline" floatLabel="always">
      <textarea matInput [(ngModel)]="comment" cols="100" rows="2"></textarea>
    </mat-form-field>
  </mat-dialog-content>
  <!-- <mat-dialog-actions style="justify-content: center; gap: 8px;">
    <button type="button" class="btn btn-primary d-flex justify-content-center align-items-center btn-add button" (click)="onDialogCancel()">Cancel</button>
    <button type="button" class="btn btn-primary d-flex justify-content-center align-items-center btn-add button" (click)="onDialogSave()" [disabled]="!comment">Save</button>
  </mat-dialog-actions> -->
  <mat-dialog-actions class="row no-gutters col-12 d-flex align-items-center justify-content-center pb-4">
    <button class="btn btn-primary button mx-2 col" (click)="onDialogSave()" [disabled]="!comment && this.status === 'RETURNED'" tabindex="1">Save</button>
    <button class="btn btn-outline-secondary mx-2 col" (click)="onDialogCancel()" tabindex="-1">Cancel</button>
  </mat-dialog-actions>
</ng-template>